import gql from "graphql-tag";

export const GENERATE_AI_RECOMMENDATIONS = gql`
  mutation GenerateFixRecommendations($sessionId: String!) {
    generateFixRecommendations(sessionId: $sessionId) {
      id
      sessionId
      flag
      url
      explanation
      fixInstructions
      priority
      estimatedImpact
      category
      isApplied
      createdAt
    }
  }
`;

export const GENERATE_AI_ACTION_PLAN = gql`
  mutation GenerateActionPlan($sessionId: String!) {
    generateActionPlan(sessionId: $sessionId) {
      id
      sessionId
      summary
      totalIssues
      criticalCount
      items
      createdAt
    }
  }
`;

export const MARK_RECOMMENDATION_APPLIED = gql`
  mutation MarkRecommendationApplied($id: String!) {
    markRecommendationApplied(id: $id)
  }
`;

export const SEND_CHAT_MESSAGE = gql`
  mutation SendChatMessage($projectId: String!, $message: String!) {
    sendChatMessage(projectId: $projectId, message: $message) {
      message
      data
      suggestedFollowUps
    }
  }
`;

export const CLEAR_CHAT_HISTORY = gql`
  mutation ClearChatHistory($projectId: String!) {
    clearChatHistory(projectId: $projectId)
  }
`;

export const UPDATE_AGENT_CONFIG = gql`
  mutation UpdateAgentConfig($data: UpdateAgentConfigInput!) {
    updateAgentConfig(data: $data) {
      id
      projectId
      isEnabled
      subAgents
      schedule
      lastRunAt
      createdAt
    }
  }
`;

export const RUN_AUTOPILOT_AGENT = gql`
  mutation RunAutopilotAgent($projectId: String!) {
    runAutopilotAgent(projectId: $projectId) {
      id
      agentType
      action
      status
      result
      error
      duration
      createdAt
    }
  }
`;

export const CHECK_SMART_ALERTS = gql`
  mutation CheckSmartAlerts($projectId: String!) {
    checkSmartAlerts(projectId: $projectId) {
      id
      type
      severity
      title
      message
      data
      isRead
      createdAt
    }
  }
`;

export const MARK_ALERT_READ = gql`
  mutation MarkAlertAsRead($id: String!) {
    markAlertAsRead(id: $id)
  }
`;

export const MARK_ALL_ALERTS_READ = gql`
  mutation MarkAllAlertsAsRead {
    markAllAlertsAsRead
  }
`;

export const CREATE_CONTENT_STRATEGY = gql`
  mutation CreateContentStrategy($data: CreateContentStrategyInput!) {
    createContentStrategy(data: $data) {
      id
      seedKeyword
      topics
      pillarPages
      clusterMap
      publishOrder
      status
      totalPieces
      completedPieces
      createdAt
    }
  }
`;

export const UPDATE_CONTENT_STRATEGY_STATUS = gql`
  mutation UpdateContentStrategyStatus($id: String!, $status: String!) {
    updateContentStrategyStatus(id: $id, status: $status)
  }
`;

export const DELETE_CONTENT_STRATEGY = gql`
  mutation DeleteContentStrategy($id: String!) {
    deleteContentStrategy(id: $id)
  }
`;

export const CREATE_AB_TEST = gql`
  mutation CreateAbTest($data: CreateAbTestInput!) {
    createAbTest(data: $data) {
      id
      projectId
      url
      testType
      originalValue
      variants
      status
      createdAt
    }
  }
`;

export const START_AB_TEST = gql`
  mutation StartAbTest($id: String!) {
    startAbTest(id: $id)
  }
`;

export const STOP_AB_TEST = gql`
  mutation StopAbTest($id: String!) {
    stopAbTest(id: $id)
  }
`;

export const EVALUATE_AB_TEST = gql`
  mutation EvaluateAbTest($id: String!) {
    evaluateAbTest(id: $id) {
      id
      url
      testType
      status
      results
      winnerIndex
    }
  }
`;

export const DELETE_AB_TEST = gql`
  mutation DeleteAbTest($id: String!) {
    deleteAbTest(id: $id)
  }
`;

export const GENERATE_REDIRECT_MAP = gql`
  mutation GenerateRedirectMap($data: GenerateRedirectMapInput!) {
    generateRedirectMap(data: $data) {
      redirects
      totalRedirects
      warnings
    }
  }
`;
